/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Ready/view.blocks to change it.
import Content from './Content/index'
import PaymentProvider from 'DesignSystem/PaymentProvider/index'
import React from 'react'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Ready({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/CreditCardCapture/Ready"
  
}) {
  return (<React.Fragment
>
<PaymentProvider
 allowReuse={false}
 paymentAccountType="PersonPaymentAccount"
 viewPath={viewPath}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PaymentProvider>
{children}
</React.Fragment>)
}